module.exports = __webpack_public_path__ + "img/logo9.ed2a2e56.jpg";